import React from "react";
import clsx from "clsx";
import styles from "./PlanningWeek.module.scss";
import WorkerLabel from "./WorkerLabel";

/**
 * Workers and prestation notes of a site's day (see siteDayDetails), in the day view and in the day panel.
 * The notes are cut at 3 lines, unless "full" (the day panel).
 */
const SiteDayDetails = ({workers, notes, full = false}) => {
  if (workers.length === 0 && notes.length === 0) {
    return null;
  }

  return <div className={clsx(styles.siteDayDetails, full && styles.full)}>
    {workers.length > 0 && <div className={styles.dayCardWorkers}>
      {workers.map(worker => <span key={worker.workerId} className={styles.worker}>
        <WorkerLabel worker={worker}/>
      </span>)}
    </div>}

    {notes.map(note => <div key={note.id} className={styles.dayCardNotes}>
      {note.description && <div className={styles.note}>
        <span className={styles.noteLabel}>Infos</span>
        <div className={styles.richText} dangerouslySetInnerHTML={{__html: note.description}}/>
      </div>}
      {note.progressReport && <div className={styles.note}>
        <span className={styles.noteLabel}>Relevé</span>
        <div className={styles.richText} dangerouslySetInnerHTML={{__html: note.progressReport}}/>
      </div>}
    </div>)}
  </div>;
};

export default SiteDayDetails;
